import React, { useState, useEffect } from "react";
import moment from "moment";
import { getJDCalendarDatesOfMonth } from "../../services/dataService";
import { jdCalenderFilter, standerdDate } from "../../utils/dataFilter";
import {
  getDailyContainerPlanning,
  getMonthlyContainerPlanning,
  getDailyContainerPlanningCarrier
} from "../../services/tractorDataService";
import { getDailyContainerPlanningAggregate } from "../../services/aggregateDataService";
import { getDailyContainerPlanningFiveM } from "../../services/fiveMDataService";
import { exportData } from "../../utils/helpers";
import Select from "react-select";
import "./MonthlyPlanviewer.css";
import { useDispatch, useSelector } from "react-redux";
import { SET_CARRIER_DASHBOARD_DATA } from "../../store/ActionTypes";

function DailyDashboardPlanViewer({
  selectedDate,
  setSelectedDate,
  selectedMonth,
  setSelectedMonth,
  dataType,
  setMonthlyData,
  selectedCarrier,
  setSelectedCarrier,
}) {
  const [jdMonthDates, setJdMonthDates] = useState([]);
  const [monthlyActualDetailData, setMonthlyActualDetailData] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [viewMode, setViewMode] = useState("daily");
  const dispatch = useDispatch();

  const carrierDashboardData = useSelector(
    (state) => state.dashboardReducer.carrierDashboardData
  );

  const reasonOptions = [
    { value: "Delay in dispatch", label: "Delay in dispatch" },
    { value: "Driver unavailable", label: "Driver unavailable" },
    { value: "Breakdown", label: "Breakdown" },
    { value: "Traffic/Weather issue", label: "Traffic/Weather issue" },
    { value: "Other", label: "Other" },
  ];

  useEffect(() => {
    async function fetchData() {
      try {
        let response;
        const formattedMonth = moment(selectedMonth).format("MMM-YY");

        if (dataType === "Tractor") {
          response = await getDailyContainerPlanning(formattedMonth);
        } else if (dataType === "Aggregate") {
          response = await getDailyContainerPlanningAggregate(formattedMonth);
        } else if (dataType === "5M") {
          response = await getDailyContainerPlanningFiveM(formattedMonth);
        } else if (dataType === "Carrier") {
          const carrierResponse = await getDailyContainerPlanningCarrier(
            formattedMonth,
            selectedCarrier
          );
          setMonthlyActualDetailData(carrierResponse?.data || []);

          dispatch({
            type: SET_CARRIER_DASHBOARD_DATA,
            payload: carrierResponse.data,
          });

          return;
        }

        setMonthlyActualDetailData(response?.data || []);

      if (dataType === "Carrier") {
  const carrierResponse = await getDailyContainerPlanningCarrier(
    formattedMonth,
    selectedCarrier
  );
  setMonthlyActualDetailData(carrierResponse?.data || []);

  dispatch({
    type: SET_CARRIER_DASHBOARD_DATA,
    payload: carrierResponse.data,
  });

  return;
}

      } catch (error) {
        console.error("Fetch error:", error);
        setMonthlyActualDetailData([]);
      }
    }

    fetchData();
  }, [dataType, selectedMonth, selectedCarrier, setMonthlyData, dispatch]);

  useEffect(() => {
    async function fetchDates() {
      try {
        const resp = await getJDCalendarDatesOfMonth(
          moment(selectedMonth).format("MMM-YYYY")
        );
        const filtered = jdCalenderFilter(resp.data);
        setJdMonthDates(filtered);
      } catch (error) {
        console.error("JD Calendar error:", error);
        setJdMonthDates([]);
      }
    }

    fetchDates();
  }, [selectedMonth]);

  const groupByDate = () => {
    const grouped = {};
    monthlyActualDetailData.forEach((item) => {
      const dateKey = moment(item.jdpydate).format("YYYY-MM-DD");
      if (!grouped[dateKey]) grouped[dateKey] = [];
      grouped[dateKey].push(item);
    });
    return grouped;
  };

  const groupByWeek = () => {
    const grouped = {};
    monthlyActualDetailData.forEach((item) => {
      const date = moment(item.jdpydate);
      const weekKey = `${date.startOf("isoWeek").format("DD MMM")} to ${date.endOf("isoWeek").format("DD MMM")}`;
      if (!grouped[weekKey]) grouped[weekKey] = [];
      grouped[weekKey].push(item);
    });
    return grouped;
  };

  const toggleRow = (key) => {
    setExpandedRows((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleReasonChange = (key, selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setSelectedReasons((prev) => ({ ...prev, [key]: selectedValues }));
  };

  const exportToExcel = () => {
    const grouped = viewMode === "weekly" ? groupByWeek() : groupByDate();
    const exportList = Object.entries(grouped).map(([key, records]) => {
      const parent = records.find((r) => r.RowType === "PARENT");
      const shortfall = (parent?.Planned_Quantity || 0) - (parent?.GateOut_Container_Count || 0);
      const reasonList = selectedReasons[key] || [];

      return {
        Group: key,
        Carrier: parent?.Carrier || "-",
        Variant: parent?.Variant || "NA",
        "Container Type": parent?.Container_Type || "NA",
        POL: parent?.POL || "NA",
        POD: parent?.POD || "NA",
        TradeLane: parent?.TradeLane || "NA",
        "Tractor Count": parent?.Planned_Quantity || 0,
        "Forecasted Container Count": parent?.Planned_Container_Count || 0,
        "Allocated Container Count": parent?.GateIn_Container_Count || 0,
        "Dispatch Container Count": parent?.GateOut_Container_Count || 0,
        "Shortfall/Excess": shortfall,
        Reasons: reasonList.join(", "),
      };
    });

    exportData(
      exportList,
      `DailyDashboard_${moment(selectedMonth).format("MMM_YYYY")}_${viewMode}`
    );
  };

  const renderRows = (groupedData) => {
    return Object.entries(groupedData).map(([key, records], idx) => {
      const children = records.filter((r) => r.RowType === "CHILD");
      const total = children.reduce(
        (acc, row) => {
          acc.Planned_Quantity += Number(row.Planned_Quantity || 0);
          acc.Planned_Container_Count += Number(row.Planned_Container_Count || 0);
          acc.GateIn_Container_Count += Number(row.GateIn_Container_Count || 0);
          acc.GateOut_Container_Count += Number(row.GateOut_Container_Count || 0);
          return acc;
        },
        {
          Planned_Quantity: 0,
          Planned_Container_Count: 0,
          GateIn_Container_Count: 0,
          GateOut_Container_Count: 0,
        }
      );

      const shortfall = total.Planned_Quantity - total.GateOut_Container_Count;
      const reasonList = selectedReasons[key] || [];

      return (
        <React.Fragment key={idx}>
          <tr className={expandedRows[key] ? "expanded-parent-row" : ""}>
            <td>
              <button
                onClick={() => toggleRow(key)}
                style={{ background: "none", border: "none", fontSize: "1.2rem", fontWeight: "bold", cursor: "pointer", color: "#007bff" }}
              >
                {expandedRows[key] ? "-" : "+"}
              </button>{" "}
              {viewMode === "weekly" ? key : standerdDate(moment(key))}
            </td>
            <td></td> {/* Market */}
<td></td> {/* Country */}
<td></td> {/* TradeLane */}
<td></td> {/* POL */}
<td></td> {/* POD */}
<td></td> {/* ICD */}
<td></td> {/* Carrier */}
<td></td> {/* Variant */}
<td></td> {/* Container Type */}

            <td>0</td>
            <td>0</td>
            <td>{total.Planned_Quantity}</td>
             <td>{total.Planned_Container_Count}</td>
            <td>{total.GateIn_Container_Count}</td>
            <td>{total.GateOut_Container_Count}</td>
           
            <td style={{ color: shortfall < 0 ? "red" : shortfall > 0 ? "green" : "black", fontWeight: "bold" }}>{shortfall}</td>
            {viewMode === "daily" && (
              <td>
                <Select
                  isMulti
                  options={reasonOptions}
                  value={(reasonList || []).map((val) => reasonOptions.find((opt) => opt.value === val))}
                  onChange={(selected) => handleReasonChange(key, selected)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select reason(s)..."
                />
              </td>
            )}
          </tr>

          {expandedRows[key] &&
            children.map((child, cIdx) => {
              const childShortfall = (child?.Planned_Quantity || 0) - (child?.GateOut_Container_Count || 0);
              return (
                <tr key={`${key}-child-${cIdx}`} className="child-row">
                  <td>{moment(child.jdpydate).format("DD MMM YYYY")}</td>
                  <td>{child.Market || "NA"}</td>
                  <td>{child.Country || "NA"}</td>
                  <td>{child.TradeLane || "NA"}</td>
                  <td>{child.Port_Of_Destination || "NA"}</td>
                  <td>{child.final_destination || "NA"}</td>
                  <td>{child.ICD || "NA"}</td>
                  <td>{child.Carrier || "NA"}</td>
                  <td>{child.Varient_PartNumber || "NA"}</td>
                  <td>{child.Container_Type || "NA"}</td>
                  <td>0</td>
                  <td> 0</td>
                  <td>{ child.Planned_Quantity || 0}</td>
                  <td>{ child.Planned_Container_Count || 0}</td>
                  <td>{child.GateIn_Container_Count || 0}</td>
                  <td>{child.GateOut_Container_Count || 0}</td>
                  <td style={{ color: childShortfall < 0 ? "red" : childShortfall > 0 ? "green" : "black", fontWeight: "bold" }}>{childShortfall}</td>
                  <td></td>
                </tr>
              );
            })}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="monthly-list-view-container">
      <div className="calendar">
        <div className="header">
          <div className="previous" onClick={() => setSelectedMonth(moment(selectedMonth).clone().subtract(1, "month"))}>
            <i className="fi-rr-angle-double-small-left"></i>
          </div>
          <div className="current">{moment(selectedMonth).format("MMMM YYYY")}</div>
          <div className="next" onClick={() => setSelectedMonth(moment(selectedMonth).clone().add(1, "month"))}>
            <i className="fi-rr-angle-double-small-right"></i>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", margin: "10px 0" }}>
        <div>
          <button onClick={() => setViewMode("daily")} className={`btn ${viewMode === "daily" ? "btn-primary" : "btn-outline-primary"}`}>Daily View</button>{" "}
          <button onClick={() => setViewMode("weekly")} className={`btn ${viewMode === "weekly" ? "btn-primary" : "btn-outline-primary"}`}>Weekly View</button>
        </div>
      </div>

      <table className="monthly-list-table">
       <thead>
  <tr>
    <th>{viewMode === "weekly" ? "Week" : "Date"}</th>
    <th>Market</th>
    <th>Country</th>
    <th>TradeLane</th>
    <th>POL</th>
    <th>POD</th>
    <th>ICD</th>
    <th>Carrier</th>
    <th>Variant</th>
    <th>Container Type</th>
    <th>Forecasted Tractor Count</th>
    <th>Forecasted Container Count</th>
    <th>Planned Tractor Count</th>
    <th>Planned Container Count</th>
    <th>Allocated Container Count</th>
    <th>Dispatched Container Count</th>
    <th>Shortfall/Excess</th>
    {viewMode === "daily" && <th>Reason</th>}
  </tr>
</thead>

        <tbody>
          {renderRows(viewMode === "weekly" ? groupByWeek() : groupByDate())}
        </tbody>
      </table>
    </div>
  );
}

export default DailyDashboardPlanViewer;